import departureCity from './fromRouter/departureCity';
import countries from './fromRouter/countries';
import checkInDateRange from './fromRouter/checkInDateRange';
import nightRange from './fromRouter/nightRange';
import touristGroup from './fromRouter/touristGroup';
import hotelCategories from './fromRouter/hotelCategories';
import meals from './fromRouter/meals';
import hotels from './fromRouter/hotels';
import warranted from './fromRouter/warranted';
import isExclusive from './fromRouter/isExclusive';

import '../../plugins/jquery.unparam.min';

export default (urlParams) => {
    if (typeof urlParams !== 'string') {
        return null;
    }

    const params = $.unparam(urlParams);

    const tourCriteria = {
        ...departureCity(params),
        ...countries(params),
        ...checkInDateRange(params),
        ...nightRange(params),
        ...touristGroup(params),
        ...hotelCategories(params),
        ...meals(params),
        ...hotels(params),
        ...warranted(params),
        ...isExclusive(params),
    };

    const element = params.toCountries;
    if (element) {
        tourCriteria.countries = element.split('.');
        if (tourCriteria.countries.length > 3) {
            tourCriteria.countries = tourCriteria.countries.slice(0, 3);
        }
    }

    const other = _.omit(params, 'fromCity', 'toCountries', 'toCountry', 'dateFrom', 'dateTo', 'dateFlexible', 'nightFrom', 'nightTo', 'adults', 'ages', 'kids', 'infants', 'hotelClass', 'hotels', 'meal', 'warranted', 'isExclusive');

    return {
        tourCriteria,
        other,
    };
};